import React from "react";

const Layers: React.FC<{ children: any }> = ({ children }) => {
  return <div>{children}</div>;
};

export default Layers;
